import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/pwd-recovery',
      name: 'pwd-recovery',
      component: () => import('./views/Pwd-recovery.vue')
    },
    {
      path: '/home',
      component: () => import('./views/Home.vue'),
      children: [
        {
          path: '',
          name: 'home',
          redirect: { name: 'documentList', params: { state: 1 } }
        },
        {
          path: '/send-invoices',
          name: 'sendInvoices',
          component: () => import('./views/SendInvoices.vue')
        },
        {
          path: '/list/:state',
          name: 'documentList',
          props: (route) => {
            const state = Number(route.params.state)
            return isNaN(state) ? { state: 1 } : { state }
          },
          component: () => import('./views/DocumentList.vue')
        },
        {
          path: '/detail/:id/:state',
          name: 'documentDetail',
          props: (route) => {
            const id = String(route.params.id)
            const state = String(route.params.state)
            return !id ? { id: '1', state: 1 }: { id, state }
          },
          component: () => import('./views/DocumentDetail.vue')
        },
        {
          path: '/user-management',
          name: 'userManagement',
          component: () => import('./views/UserManagement.vue')
        },
        {
          path: '/user-detail',
          name: 'userDetail',
          component: () => import('./views/UserDetail.vue')
        },
        {
          path: '/supplier-management',
          name: 'supplierManagement',
          component: () => import('./views/SupplierManagement.vue')
        },
        {
          path: '/supplier-detail',
          name: 'supplierDetail',
          component: () => import('./views/SupplierDetail.vue')
        },
        {
          path: '/approval',
          name: 'approval',
          component: () => import('./views/Approval.vue')
        },
        {
          path: '/user-profile',
          name: 'userProfile',
          component: () => import('./views/UserProfile.vue')
        }
      ]
    },
    {
      path: '/:pathMatch(.*)*',
      component: () => import('./views/Home.vue')
    }
  ]
})
